import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { ManifestIntegration } from 'models'
import { stepsImages } from '../../../setupIntegration.constants'
import { InstructionsWrapper } from '../../jiraWizard.styles'
import { INSTRUCTIONS_DESCRIPTION, INSTRUCTIONS_TITLE } from '../wizard.constants'

interface Props {
  integration: ManifestIntegration
  instructions: RegExpMatchArray | null
  loading?: boolean
}

/* The connection step's right pane: the integration's numbered documentation,
 * each entry shown as a captioned screenshot. */
const InstructionsPane: FC<Props> = ({ integration, instructions, loading }) => {
  const documentationPath = integration.documentation?.path
  const hasImage = (index: number) => !!documentationPath && !!stepsImages[documentationPath]?.includes(index)

  return (
    <InstructionsWrapper>
      <Typography className="instructions-title">{INSTRUCTIONS_TITLE}</Typography>
      {!loading && (
        <Typography className="instructions-description">
          {instructions?.length ? INSTRUCTIONS_DESCRIPTION : 'N/A'}
        </Typography>
      )}

      <Box className="instructions-steps">
        {instructions?.map((instruction, index) => {
          const stepNumber = index + 1

          return (
            <Box className="instruction-step" key={instruction}>
              <Typography className="instruction-step-title">STEP {stepNumber}</Typography>

              {hasImage(stepNumber) && (
                <Zoom>
                  <img
                    alt={`step_${stepNumber}_image`}
                    src={`/${documentationPath}_step_${stepNumber}.png`}
                    className="instruction-step-image"
                  />
                </Zoom>
              )}

              <Box className="instruction-step-content">
                <ReactMarkdown rehypePlugins={[rehypeRaw]}>{instruction.slice(3)}</ReactMarkdown>
              </Box>
            </Box>
          )
        })}
      </Box>
    </InstructionsWrapper>
  )
}

export default InstructionsPane
